import React, { useState, useEffect, useRef } from "react";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const OurExpertise = (props) => {
  const ourExpertise = props.dataOurExpertise?.expertise_items || [];
  const title = props.dataOurExpertise?.head || "Our Expertise";
  const baseUrl = props.url || "";
  const homeUrl=props.homeurl || "";

  // State to track active image and transitions
  const [activeImage, setActiveImage] = useState(null);
  const [previousImage, setPreviousImage] = useState(null);
  const [transitionDirection, setTransitionDirection] = useState("right");

  const headerRef = useRef(null); // Reference to the header for animation

  // Set the initial active image when data is available
  useEffect(() => {
    if (ourExpertise.length > 0) {
      setActiveImage(ourExpertise[0].image);
    }
  }, [ourExpertise]);

  // Handle scroll animations
  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        const sectionTop = headerRef.current.getBoundingClientRect().top;
        const viewportHeight = window.innerHeight;

        // Add animation class when the header comes into view
        if (sectionTop < viewportHeight - 100) {
          headerRef.current.classList.add("animate");
        }
      }
    };

    // Dynamically load the Spline viewer script
    const script = document.createElement("script");
    script.type = "module";
    script.src = "https://unpkg.com/@splinetool/viewer@1.9.54/build/spline-viewer.js";
    document.body.appendChild(script);

    window.addEventListener("scroll", handleScroll);

    return () => {
      document.body.removeChild(script);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Handle mouse hover to update active image
  const handleMouseEnter = (newImage, index) => {
    if (newImage !== activeImage) {
      setPreviousImage(activeImage);

      // Determine transition direction
      const currentIndex = ourExpertise.findIndex(
        (item) => item.image === activeImage
      );
      setTransitionDirection(index > currentIndex ? "right" : "left");

      setActiveImage(newImage);
    }
  };

  return (
    <div className="our-expertise">
      <div className="container">
        <h2 ref={headerRef} className="universal-header">{title}</h2>
        <div className="ourexpertise-container">
          {/* Left Side: Image */}
          <div className="ourexpertise-image">
            {ourExpertise.map((expertise) => (
              <div
                key={expertise.title}
                className={`${
                  expertise.image === activeImage
                    ? `active ${transitionDirection}`
                    : expertise.image === previousImage
                    ? `previous ${transitionDirection}`
                    : ""
                }`}
              >
                {expertise.image === activeImage && (
                  <img
                    src={baseUrl + expertise.image}
                    alt={expertise.title}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                )}
              </div>
            ))}
          </div>

          {/* Right Side: Cards */}
          <div className="ourexpertise-cards slide-left">
            {ourExpertise.map((expertise, index) => (
              <div
                key={expertise.title}
                className={`ourexpertise-card ${
                  activeImage === expertise.image ? "active" : ""
                }`}
                onMouseEnter={() => handleMouseEnter(expertise.image, index)}
              >
                <h3>{expertise.title}</h3>
                <p>{expertise.description}</p>
                {expertise.button_name!==null ? 
                  <a href={homeUrl+expertise.button_link} className="viewmore-btn">
                   {expertise.button_name}
                   <svg
                     xmlns="http://www.w3.org/2000/svg"
                     width="42"
                     height="42"
                     viewBox="0 0 48 48"
                     fill="none"
                   >
                     <rect width="48" height="48" fill="none" />
                     <path
                       d="M16 32L32 16M32 16H20M32 16V28"
                       stroke="#fff"
                       strokeWidth="2"
                       strokeLinecap="round"
                       strokeLinejoin="round"
                     />
                   </svg>
                  </a>
                  : null
                }
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurExpertise;
